<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline"
              @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6"
                 :lg="7"
                 :md="8"
                 :sm="24">
            <a-form-item :label="language['gift_company']">
              <a-input :placeholder="language['gift_company_input']"
                       v-model="queryParam.company"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6"
                 :lg="7"
                 :md="8"
                 :sm="24">
            <span style="float: left;overflow: hidden;"
                  class="table-page-search-submitButtons">
              <a-button type="primary"
                        @click="searchQuery"
                        icon="search">{{language['common.searchButton']}}</a-button>
              <a-button type="primary"
                        @click="searchReset"
                        icon="reload"
                        style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd"
                type="primary"
                icon="plus"
                v-has="'supplier:add'">{{language['common.insertButton']}}</a-button>

      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1"
                       @click="batchDel">
            <a-icon type="delete" />{{language['common.delete']}}
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"
                  v-has="'supplier:delete'">{{language['common.batchAction']}}
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info"
           style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{language['common.choosed']}}  <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>{{language['common.item']}}
        <a style="margin-left: 24px"
           @click="onClearSelected">{{language['common.clear']}}</a>
      </div>
      <a-table ref="table"
               size="middle"
               :scroll="{x:true}"
               bordered
               rowKey="id"
               :columns="columns"
               :dataSource="dataSource"
               :pagination="ipagination"
               :loading="false"
               :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
               class="j-table-force-nowrap"
               @change="handleTableChange">

        <span slot="action"
              slot-scope="text, record">
          <div v-if="record.approveStatus === 0">
            <a @click="handlePassAndRefuse(record,1)"
               v-has="'supplier:pass'">{{language['gift_vendor_pass']}}</a>
            <a-divider type="vertical" />
            <a @click="handlePassAndRefuse(record,2)"
               v-has="'supplier:refuse'">{{language['common.reject']}}</a>
          </div>
          <div v-else>
            <a @click="handleEdit(record)"
               v-has="'supplier:edit'">{{language['common.edit']}}</a>

            <a-divider type="vertical" />
            <a-dropdown>
              <a class="ant-dropdown-link">{{language['common.more']}}
                <a-icon type="down" />
              </a>
              <a-menu slot="overlay">
                <a-menu-item>
                  <a @click="handleDetail(record)">{{language['common.detailsButton']}}</a>
                </a-menu-item>
                <a-menu-item v-has="'supplier:delete'">
                  <a-popconfirm :title="language['common.deleteConfirmInfo']"
                                @confirm="() => handleDelete(record)">
                    <a>{{language['common.delete']}}</a>
                  </a-popconfirm>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </div>
        </span>

        <span slot='appName' slot-scope='appId,record,index'>
          {{ appDataMap[appId] }}
        </span>

        <span slot="customStatus"
              slot-scope="status, record, idx">
          <a-switch :checked='status'
                    @change="onSwitchChange(status,record, idx)"
                    :disabled=' record.approveStatus === 0 || record.approveStatus === 2'></a-switch>
        </span>

      </a-table>
    </div>

    <gift-company-modal ref="modalForm"
                       @ok="modalFormOk" ></gift-company-modal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import GiftCompanyModal from './modules/GiftCompanyModal.vue'
import { httpAction, getAction, postAction, deleteAction,downFile } from '@/api/manage'

export default {
  name: 'GiftCompanyList',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    GiftCompanyModal,
  },
  data() {
    const language = this.$store.getters.language
    return {
      disableMixinCreated: false,
      description: '法人管理页面',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: language['gift_company'],
          align: 'center',
          dataIndex: 'company',
        },
        {
          title: language['gift_company_desc'],
          align: 'center',
          dataIndex: 'companyDesc',
        },
        {
          title: language['common.action'],
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/gift/company/list',
        delete: '/gift/company/delete',
        deleteBatch: '/gift/vendor/deleteBatch',
      },
      appLimit:{
        flag: false,
        value: undefined
      }
    }
  },
  created() {
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
    language() {
      return this.$store.getters.language
    },
  },
  methods: {
    searchReset(){
      this.queryParam = {};
      if (this.appLimit.flag){
        this.queryParam.appId = this.appLimit.value;
      }
      this.supplierCode = undefined;
      this.loadData(1);
    },
    async checkAppLimit(){
      await getAction(this.url.checkAppLimit).then(res=>{
        if (res.success){
          this.appLimit.flag = true;
          this.appLimit.value = res.result;
          this.queryParam.appId = res.result;
        }
      })
      this.loadData(1);
    },
    getAppDataMap(){
      getAction(this.url.getAppDataMap).then(res=>{
        this.appDataMap = res.result;
      })
    },
    handleDelete: function (record) {
      if (!this.url.delete) {
        this.$message.error('请设置url.delete属性!')
        return
      }
      var that = this
      deleteAction(that.url.delete, { id: record.id }).then((res) => {
        if (res.success) {
          //重新计算分页问题
          that.reCalculatePage(1)
          that.$message.success(res.message)
          that.loadData()
          this.onClearSelected()
        } else {
          that.$message.warning(res.message)
        }
      })
    },

    batchDel: function () {
      if (!this.url.deleteBatch) {
        this.$message.error('请设置url.deleteBatch属性!')
        return
      }

      console.log('this.selectionRows : ', this.selectionRows)
      if (this.selectionRows.length <= 0) {
        this.$message.warning('請選擇一條記錄！')
        return
      } else {
        let codeList = this.selectionRows.map((item, index, arr) => {
          let c = { code: item.code }
          return c
        })
        let ids = codeList.map((item) => item.code).join(',')

        var that = this
        this.$confirm({
          title: '確認刪除',
          content: '是否刪除選中數據?',
          onOk: function () {
            that.loading = true
            deleteAction(that.url.deleteBatch, { codes: ids })
              .then((res) => {
                if (res.success) {
                  //重新计算分页问题
                  that.reCalculatePage(that.selectedRowKeys.length)
                  that.$message.success(res.message)
                  that.loadData()
                  that.onClearSelected()
                } else {
                  that.$message.warning(res.message)
                }
              })
              .finally(() => {
                that.loading = false
              })
          },
        })
      }
    },

    handlePassAndRefuse(record, approveStatus) {
      record.approveStatus = approveStatus
      httpAction(this.url.passAndRefuseUrl, record, 'put').then((res) => {
        if (res.success) {
          this.searchQuery()
        } else {
          this.$message.warning(res.message)
        }
      })
    },

    onSwitchChange(checked, record, idx) {
      console.log('data', this.dataSource)
      console.log('checked', checked)
      console.log('record', record)
      postAction(this.url.turnStatus, record).then((res) => {
        if (res.success) {
          // this.loadData();
          if (this.dataSource[idx]) this.dataSource[idx].status = checked === 0 ? 1 : 0
          return true
        } else {
          this.$message.error(res.message)
          return false
        }
      })
    },


  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
